import styled from "@emotion/styled"

const TitleDescription = styled.span({
  fontSize: "15px",
  fontFamily: "Avenir Next",
  display: "block",
  color: "#300",
  textAlign: "center",
  fontWeight: "bold",
})

export default TitleDescription
